/**
 * Контекст за мониторинг в реално време – данните и интервалът са в store извън React.
 * При навигация мониторингът не спира; спира само при „Стоп“.
 */
import React, { createContext, useContext, useState, useEffect } from 'react';
import * as store from './realtimeMonitoringStore';

const RealtimeMonitoringContext = createContext(null);

export function RealtimeMonitoringProvider({ children }) {
  const [state, setState] = useState(() => store.getState());

  useEffect(() => {
    const unsub = store.subscribe((newState) => setState(newState));
    return unsub;
  }, []);

  // Стартирай само ако е бил активен преди И в момента не тече
  useEffect(() => {
    const wasActive =
      typeof sessionStorage !== 'undefined' &&
      sessionStorage.getItem('fireguard_realtime_monitoring_active') === 'true';
    const alreadyRunning = store.getState().monitoringActive;
    if (wasActive && !alreadyRunning) store.startMonitoring();
  }, []);

  const value = {
    monitoringActive: state.monitoringActive,
    currentData: state.currentData,
    tempData: Array.isArray(state.tempData) ? state.tempData : [],
    smokeData: Array.isArray(state.smokeData) ? state.smokeData : [],
    timeLabels: Array.isArray(state.timeLabels) ? state.timeLabels : [],
    startMonitoring: store.startMonitoring,
    stopMonitoring: store.stopMonitoring,
    updateRealtimeData: store.updateRealtimeData,
    MAX_DATA_POINTS: store.MAX_DATA_POINTS
  };

  return (
    <RealtimeMonitoringContext.Provider value={value}>
      {children}
    </RealtimeMonitoringContext.Provider>
  );
}

export function useRealtimeMonitoring() {
  const ctx = useContext(RealtimeMonitoringContext);
  if (!ctx) throw new Error('useRealtimeMonitoring must be used within RealtimeMonitoringProvider');
  return ctx;
}

const EMPTY_SNAPSHOT = {
  monitoringActive: false,
  currentData: null,
  tempData: [],
  smokeData: [],
  timeLabels: []
};

/** Директен абонамент за данните – при монтиране винаги взимай актуалния state от store (важно след връщане на страницата) */
export function useRealtimeMonitoringData() {
  const [snapshot, setSnapshot] = useState(() => store.getState());
  useEffect(() => {
    setSnapshot(store.getState());
    const unsub = store.subscribe((next) => setSnapshot(next || EMPTY_SNAPSHOT));
    // При връщане на страницата синхронизирай отново след кратко закъснение, за да се обновят графиките
    const t1 = setTimeout(() => setSnapshot(store.getState()), 50);
    const t2 = setTimeout(() => setSnapshot(store.getState()), 200);
    return () => {
      unsub();
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);
  return snapshot || EMPTY_SNAPSHOT;
}
